import React from "react";

export default function FaqInfoText({ children }) {
  return <p className='info-text'>{children}</p>;
}
